import type { FieldError } from 'react-hook-form';

import type { MessageType } from '@/hooks/messages';
import { useMessages } from '@/hooks/messages';

import { fieldErrorMessageDefinitions } from './messages';

interface FieldErrorsProps {
  error: FieldError | undefined;
}

const getErrorMessages = (
  error: FieldError,
  messages: MessageType<typeof fieldErrorMessageDefinitions>,
): string[] => {
  if (error.message) {
    return [error.message];
  }
  if (error.type) {
    switch (error.type) {
      case 'required':
        return [messages.required()];
      case 'maxLength':
        return [messages.maxLength()];
      case 'server':
        return error.message ? [error.message] : [messages.wrongValue()];
      default:
        return [messages.wrongValue()];
    }
  }
  if (error.types) {
    return Object.values(error.types).flatMap((validateResult) => {
      if (typeof validateResult === 'string') {
        return [validateResult];
      }
      if (typeof validateResult === 'boolean') {
        return messages.wrongValue();
      }
      if (validateResult === undefined) {
        console.error('FieldErrors: unhandled undefined validateResult', error);
        return [];
      }
      return validateResult;
    });
  }

  console.error('FieldErrors: unhandled error shape', error);
  return [];
};

export const FieldErrors = ({ error }: FieldErrorsProps) => {
  const messages = useMessages(fieldErrorMessageDefinitions);

  if (error === undefined) {
    return null;
  }

  return getErrorMessages(error, messages).map((message) => {
    return (
      <p className='text-danger text-sm' key={message}>
        {message}
      </p>
    );
  });
};

export default FieldErrors;
